export const calculateBackseatPrice = ({
  baseAmount = 0,        // 10_000_000             // 0.001 (0.1%)
  seatCount = 0,         // số người
  durationInMonths = 12, // thời hạn
  supplier = "VNI",
}) => {
  let feeSchedule = 0;
  if (durationInMonths === 12) {
    feeSchedule = 1;
  } else if (durationInMonths === 18) {
    feeSchedule = 1.4;
  } else if (durationInMonths === 24) {
    feeSchedule = 1.8;
  } else if (durationInMonths === 36) {
    feeSchedule = 2.6;
  }
  console.log("data:", baseAmount, seatCount, durationInMonths, supplier, feeSchedule);
  if (
    baseAmount <= 0 ||
    seatCount <= 0 ||
    durationInMonths <= 0
  ) {
    return 0;
  }
  const rate = 0.001; // 0.1%

  const durationInYears = durationInMonths / 12;
  if (supplier === "PVI") {
    return (
      baseAmount *
      rate *
      seatCount *
      feeSchedule
    );
  }
  return (
    baseAmount *
    rate *
    seatCount *
    durationInYears
  );
};
